<template>
  <div class="textarea-c">
<textarea
  ref="textarea"
  :class="textareaClasses"
  :style="textareaStyles"
  :placeholder="placeholder"
  :disabled="disabled"
  :rows="rows"
  :maxlength="maxlength"
  :readonly="readonly"
  :name="name"
  :value="currentValue"
  @keyup.enter="handleEnter"
  @focus="handleFocus"
  @blur="handleBlur"
  @input="handleInput">
</textarea>

 <div class="txtnumber" v-show="showCounter && maxlength"><span>{{ count }}</span>/{{maxlength}}</div>

  </div>
</template>

<script>
  import { oneOf, findComponentUpward } from '../../utils/assist';
  import calcTextareaHeight from '../../utils/calcTextareaHeight';
  import Emitter from '../../mixins/emitter';

  const prefixCls = 'txtinput';

  export default {
    name: 'Ftextarea',
    mixins: [ Emitter ],
    props: {
      type: {
        validator (value) {
          return oneOf(value, ['textarea']);
        },
        default: 'textarea'
      },
      value: {
        type: [String, Number],
        default: ''
      },
      showCounter: {
        type: Boolean,
        default: true
      },
      size: {
        validator (value) {
          return oneOf(value, ['small', 'large']);
        }
      },
      placeholder: {
        type: String,
        default: ''
      },
      maxlength:Number,
      disabled: {
        type: Boolean,
        default: false
      },
      icon: String,
      autosize: {
        type: [Boolean, Object],
        default: false
      },
      rows: {
        type: Number,
        default: 2
      },
      readonly: {
        type: Boolean,
        default: false
      },
      name: {
        type: String
      },
      number: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        currentValue: this.value,
        prefixCls: prefixCls,
        prepend: true,
        append: true,
        slotReady: false,
        textareaStyles: {}
      };
    },
    computed: {
      wrapClasses () {
        return [
          `${prefixCls}-wrapper`,
          {
            [`${prefixCls}-wrapper-${this.size}`]: !!this.size,
            [`${prefixCls}-type`]: this.type,
            [`${prefixCls}-group`]: this.prepend || this.append,
            [`${prefixCls}-group-${this.size}`]: (this.prepend || this.append) && !!this.size,
            [`${prefixCls}-group-with-prepend`]: this.prepend,
            [`${prefixCls}-group-with-append`]: this.append,
            [`${prefixCls}-hide-icon`]: this.append  // #554
          }
        ];
      },
      inputClasses () {
        return [
          `${prefixCls}`,
          {
            [`${prefixCls}-${this.size}`]: !!this.size,
            [`${prefixCls}-disabled`]: this.disabled
          }
        ];
      },
      textareaClasses () {
        return [
          `${prefixCls}`,
          {
            [`${prefixCls}-disabled`]: this.disabled
          }
        ];
      },
      count () {
        let len = this.maxlength
        if (this.currentValue) {
          len = this.maxlength - this.currentValue.length //.replace(/\n/g, 'aa')
        }
        return len > this.maxlength ? this.maxlength : len
      },
    },
    methods: {
      handleEnter (event) {
        this.$emit('on-enter', event);
      },
      handleIconClick (event) {
        this.$emit('on-click', event);
      },
      handleFocus (event) {
        this.$emit('on-focus', event);
      },
      handleBlur (event) {
        this.$emit('on-blur', event);
        if (!findComponentUpward(this, ['DatePicker', 'TimePicker', 'Cascader', 'Search'])) {
          this.dispatch('FormItem', 'on-form-blur', this.currentValue);
        }
      },
      handleInput (event) {
        let value = event.target.value;
        if (this.number) value = Number.isNaN(Number(value)) ? value : Number(value);
        this.$emit('input', value);
        this.setCurrentValue(value);
        this.$emit('on-change', event);
      },
      handleChange (event) {
        this.$emit('on-input-change', event);
      },
      setCurrentValue (value) {
        if (value === this.currentValue) return;
        this.$nextTick(() => {
          this.resizeTextarea();
      });
        this.currentValue = value;
        if (!findComponentUpward(this, ['DatePicker', 'TimePicker', 'Cascader', 'Search'])) {
          this.dispatch('FormItem', 'on-form-change', value);
        }
      },
      resizeTextarea () {
        const autosize = this.autosize;
        if (!autosize || this.type !== 'textarea') {

          return false;
        }

        const minRows = autosize.minRows;
        const maxRows = autosize.maxRows;
        this.textareaStyles = calcTextareaHeight(this.$refs.textarea, minRows, maxRows);
      }
    },
    watch: {
      value (val) {
        this.setCurrentValue(val);
      },
      currentValue (newVal) {
        if (this.maxlength && newVal && newVal.length >= this.maxlength) {
           this.currentValue = newVal.slice(0, this.maxlength)
        }
        this.$emit('input', this.currentValue)
        this.$emit('on-change', this.currentValue)
      }
    },
    mounted () {
      this.currentValue = this.value
        this.prepend = false;
        this.append = false;
      this.slotReady = true;
      this.resizeTextarea();
    }
  };
</script>




// WEBPACK FOOTER //
// src/components/Ftextarea/Ftextarea.vue